import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { DataService_SchoolIncidentTypeSetup } from "../shared/data.service";
import { EditSchoolIncidentTypeRequest } from "../shared/EditSchoolIncidentTypeRequest";
import { SchoolIncidentTypeInUseRequest } from "../shared/SchoolIncidentTypeInUseRequest";

@Component({
	selector: "app-school-edit-sitype",
	templateUrl: "./school-edit-sitype.component.html",
	styleUrls: ["./school-edit-sitype.component.css"],
})
export class SchoolEditSITypeComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private SchoolIncidentTypeSetupService: DataService_SchoolIncidentTypeSetup
	) {}

	ngOnInit(): void {
		//Get data from parent
		this.SchoolID = this.dialogConfig.data.SchoolID;
		this.user = this.dialogConfig.data.user;
		this.SelectedType = this.dialogConfig.data.SelectedType;

		this.SchoolIncidentTypeCD = String(this.SelectedType.SchoolIncidentTypeCD);
		this.SchoolIncidentTypeDesc = String(this.SelectedType.SchoolIncidentTypeDesc);

		this.OriginalCD = String(this.SelectedType.SchoolIncidentTypeCD);
		this.OriginalDesc = String(this.SelectedType.SchoolIncidentTypeDesc);

		//INSERT LOAD COMBO BOX DATA
	}

	///////////////////////////////////////
	// Data
	///////////////////////////////////////

	errorMessage: any = "";

	//Data from parent
	SchoolID: any;
	user: any;
	SelectedType: any;

	//INSERT FORM DATA
	SchoolIncidentTypeCD: any = "";
	SchoolIncidentTypeDesc: any = "";

	OriginalCD: any = "";
	OriginalDesc: any = "";

	///////////////////////////////////////

	///////////////////////////////////////
	// Buttons
	///////////////////////////////////////

	//INSERT CUSTOM BUTTON METHODS
	onEditType() {
		this.errorMessage = "";

		//Error handling
		if (this.SchoolIncidentTypeCD == "") {
			this.errorMessage = "Enter a Code";
			return;
		}

		if (this.SchoolIncidentTypeDesc == "") {
			this.errorMessage = "Enter a Description";
			return;
		}

		if (this.SchoolIncidentTypeCD != this.OriginalCD) {
			this.CheckCode();
		} else if (this.SchoolIncidentTypeDesc != this.OriginalDesc) {
			this.CheckDesc();
		} else {
			this.FinishEdit();
		}
	}

	CheckCode() {
		let parms: SchoolIncidentTypeInUseRequest = {
			str: this.SchoolIncidentTypeCD,
			SchoolID: this.SchoolID,
		};

		var result = this.SchoolIncidentTypeSetupService.SchoolIncidentTypeCDInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Code already used";
					return;
				} else {
					if (this.SchoolIncidentTypeDesc != this.OriginalDesc) {
						this.CheckDesc();
					} else {
						this.FinishEdit();
					}
				}
			},
			(error) => {}
		);
	}

	CheckDesc() {
		let parms: SchoolIncidentTypeInUseRequest = {
			str: this.SchoolIncidentTypeDesc,
			SchoolID: this.SchoolID,
		};

		var result = this.SchoolIncidentTypeSetupService.SchoolIncidentTypeDescInUse(parms);
		result.subscribe(
			(response) => {
				if (response) {
					this.errorMessage = "Description already used";
					return;
				} else {
					this.FinishEdit();
				}
			},
			(error) => {}
		);
	}

	FinishEdit() {
		// @SchoolIncidentTypeID INT,
		// @SchoolIncidentTypeCD VARCHAR(20),
		// @SchoolIncidentTypeDesc VARCHAR(120)

		let parms: EditSchoolIncidentTypeRequest = {
			SchoolIncidentTypeID: this.SelectedType.SchoolIncidentTypeID,
			SchoolIncidentTypeCD: this.SchoolIncidentTypeCD,
			SchoolIncidentTypeDesc: this.SchoolIncidentTypeDesc,
		};

		var result = this.SchoolIncidentTypeSetupService.EditType(parms);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "School Incident Type was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the School Incident Type",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////
}
